export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
            <i className="ri-smartphone-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
            51吃瓜 App 客户端
          </h2>
          <p className="text-sm text-foreground-600 mb-8">
            随时随地刷最新吃瓜资讯，iOS / Android 双端覆盖，第一时间推送51吃瓜网今日吃瓜热门更新。
          </p>
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 bg-background-50 rounded-xl border border-background-200/70">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-chat-smile-2-line text-3xl text-background-50 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <div className="text-left">
              <h3 className="text-lg font-bold font-heading text-foreground-900">51吃瓜 App</h3>
              <p className="text-xs text-foreground-500 mt-1">v3.8.2 · 12.4MB · 安全纯净</p>
              <p className="text-xs text-foreground-400 mt-1">已服务超过 300 万吃瓜群众，评分 4.8</p>
            </div>
            <a
              href="#app"
              className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-1 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
              立即下载
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}